import { FileActionType } from '../../../../../../../shared/components/file-actions/enums/FileActionType';
import { TimeFrame } from '../../../../../../../shared/entities/filters/enum/TimeFrame';
import { ViewSummaryAlignType } from '../../../../../../../shared/entities/view/components/view/enums/ViewSummaryAlignType';
import { ScreenOptions } from '../../../interfaces/ScreenOptions';

export const staticScreenInUseOptions: Partial<ScreenOptions> = {
  isLanding: false,
  toolbar: {
    fileActionTypes: [FileActionType.Save, FileActionType.Excel, FileActionType.Print],
    quickFilter: {
      hasLocation: true,
      timeFrameOptions: [TimeFrame.Month, TimeFrame.Quarter, TimeFrame.YTD, TimeFrame.Year, TimeFrame.All],
      hasTimeFrameRange: true,
      hasDateRange: true,
      hasIncludeAShares: true,
      hasIncludeSPAC: true,
    },
  },
  summary: {
    align: ViewSummaryAlignType.Grid,
  },
};
